import { render } from "./SSOView.vue?vue&type=template&id=17d18b0b"
import script from "./SSOView.vue?vue&type=script&lang=js"
export * from "./SSOView.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__